import router from '../router';
import analytics from './analytics';
import helpers, {lastPageYOffset} from '../helpers';
import parallax from './parallax';

const modalToArrayEntries = Object.entries(window.data.modals);

function modalScroll() {
	const y = document.querySelector('.modal__wrapper').getBoundingClientRect().top;

	helpers.$header.style.top = `${y}px`;
}

function setContent(id, $body) {
	// eslint-disable-next-line no-unused-vars
	const type = id.split('-')[0];
	const content = window.data.modals[id];
	let html = '';

	if (type === 'person') {
		$body.classList.add('modal__body--person');
		html = `
			<div class="modal__person">
				<picture class="modal__person-media">
					<img
						${content.src ? `src="${window.baseDir}images/home/${content.src}"` : false}
						${content.srcset ? `srcset="${window.baseDir}images/home/${content.srcset} 2x"` : false}
						alt="${content.name ? content.name : 'фото'}">
				</picture>
				<div class="modal__person-body">
					${content.name ? `<h2 class="modal__person-name">${content.name}</h2>` : ''}
					${content.role ? `<div class="modal__person-role">${content.role}</div>` : ''}
				</div>
			</div>
			${content.title ? `<h3 class="modal__subtitle modal-title">${content.title}</h3>` : ''}
			${content.text ? `<div class="modal__text">${content.text}</div>` : ''}
			${content.afterwords ? `<div class="modal__afterwords">${content.afterwords}</div>` : ''}
		`;
	} else if (type === 'product') {
		let innerHtml = '';

		for (let i = 0; i < content.content.length; i++) {
			const body = content.content[i];
			if (body.type === 'text') {
				innerHtml += `<div class="modal__text">${body.text}</div>`;
			}

			if (body.type === 'media') {
				let images = '';
				if (body.images.length) {
					for (let j = 0; j < body.images.length; j++) {
						const image = body.images[j];

						images += `<img
							${image.src ? `src="${window.baseDir}images/home/${image.src}"` : false}
							${image.srcset ? `srcset="${window.baseDir}images/home/${image.srcset} 2x"` : false}
							alt="фото">`;
					}
				} else {
					images = `<img
						${body.images.src ? `src="${window.baseDir}images/home/${body.images.src}"` : false}
						${body.images.srcset ? `srcset="${window.baseDir}images/home/${body.images.srcset} 2x"` : false}
						alt="фото">`;
				}

				innerHtml += `
					<picture class="modal__product-media${body.class ? ` modal__product-media--${body.class}` : ''}">
						${images}
					</picture>
				`;
			}
		}

		html = `
			${content.title ? `<h3 class="modal__title modal-title">${content.title}</h3>` : ''}
			${content.text ? `<div class="modal__text">${content.text}</div>` : ''}
			${innerHtml ? innerHtml : ''}
		`;
	} else {
		html = `
			${content.title ? `<h3 class="modal__title modal-title">${content.title}</h3>` : ''}
			${content.text ? `<div class="modal__text">${content.text}</div>` : ''}
		`;
	}

	$body.innerHTML = html;

	setTimeout(() => {
		analytics.modalLinks();
	}, 0);
}

function open(id, $item, isArrowDesktop = false) {
	if (helpers.modalLocked) {
		return;
	}
	if (!helpers.isMobile()) {
		helpers.handlerPointerEvents.remove();
	}
	helpers.modalLocked = true;

	document.querySelector('.modal__navigate--desktop').classList.remove('is-hidden');

	const modal = document.querySelector('.modal');
	const body = modal.querySelector('.modal__body');

	let prevId;
	let nextId;

	if (!document.querySelector('.grid').classList.contains('is-modal-opened')) {
		document.querySelector('.grid').classList.add('is-modal-opened');
	}

	if (!isArrowDesktop) {
		setContent(id, body);
	}

	setTimeout(() => {
		parallax.disabled();
		modal.classList.remove('is-hidden');
		modal.querySelector('.modal__scroller').removeAttribute('data-scroll');
		modal.setAttribute('aria-hidden', false);

		if (helpers.isMobile()) {
			gsap.from(body, {
				duration: 1,
				autoAlpha: 0,
				clearProps: 'all',
				onStart() {
					modal.querySelector('.modal__scroller').scrollTop = 0;
				},
				onComplete() {
					modal.classList.remove('is-hidden');
					modal.classList.add('is-active');
					document.documentElement.dataset.modal = id;

					helpers.modalLocked = false;
				},
			});
		} else {
			let x = 0;
			let y = 0;
			let width = null;
			let height = null;

			if (!isArrowDesktop) {
				x = pageXOffset / 2;
				y = pageYOffset / 2 - body.offsetHeight / 2;

				// width = $item.offsetWidth;
				// height = $item.offsetHeight;
			}

			gsap.from(body, {
				duration: 0.7,
				autoAlpha: 0,
				ease: 'power1.in',
				scale: 0,
				x,
				y,
				width,
				height,
				clearProps: 'all',
				onStart() {
					if (isArrowDesktop) {
						setContent(id, body);
					}

					modal.querySelector('.modal__scroller').scrollTop = 0;

					const vh = body.offsetHeight;
					body.parentElement.style.setProperty('--height', `${vh}px`);

					helpers.modalLocked = false;
					helpers.handlerPointerEvents.add();
				},
				onComplete() {
					modal.classList.remove('is-hidden');
					modal.classList.add('is-active');
					document.documentElement.dataset.modal = id;
					body.parentElement.style.setProperty('--height', '100%');

					// setTimeout(() => {
					// 	helpers.modalLocked = false;
					// 	helpers.handlerPointerEvents.add();
					// }, 1000);
				},
			});
		}
	}, 0);

	setTimeout(() => {
		helpers.dispatcher.trigger('cards-show', {name: body.querySelector('.modal-title').textContent});
		// console.log('setTimeout.');
	}, 100);

	document.querySelectorAll('.header__link').forEach((item) => {
		item.classList.remove('is-active');

		if (item.dataset.link === id) {
			// document.querySelector(`[data-link="${id}"]`).classList.add('is-active');
			item.classList.add('is-active');
		}
	});

	if (helpers.isMobile()) {
		helpers.$body.style.setProperty('top', `-${lastPageYOffset}px`);
		helpers.$html.classList.add('is-lock-scroll');
		helpers.$body.style.setProperty('padding-right', `${helpers.getScrollbarWidth()}px`);
		helpers.$header.style.setProperty('right', `${helpers.getScrollbarWidth()}px`);
		helpers.$header.classList.add('is-menu-opened');

		document.querySelector('.modal__scroller').addEventListener('scroll', modalScroll, false);
	}

	for (let i = 0; i < modalToArrayEntries.length; i++) {
		const element = modalToArrayEntries[i];

		if (element[0] === id) {
			// eslint-disable-next-line no-nested-ternary
			prevId = i - 1 >= 0 ? i - 1 : modalToArrayEntries.length - 1;
			nextId = i + 1 < modalToArrayEntries.length ? i + 1 : 0;
		}
	}

	document.querySelectorAll('.js-modal-arrow-prev').forEach((el) => {
		el.dataset.target = prevId;
	});

	document.querySelectorAll('.js-modal-arrow-next').forEach((el) => {
		el.dataset.target = nextId;
	});
}

function close() {
	if (helpers.modalLocked) {
		return;
	}

	helpers.handlerPointerEvents.remove();
	document.documentElement.removeAttribute('data-modal');

	document.querySelector('.modal__navigate--desktop').classList.add('is-hidden');

	document.querySelectorAll('.grid-item.is-active').forEach((el) => {
		el.classList.remove('is-active');
	});

	const modal = document.querySelector('.modal');
	const body = modal.querySelector('.modal__body');
	modal.setAttribute('aria-hidden', true);

	if (helpers.isMobile()) {
		helpers.$body.style.removeProperty('top');
		helpers.$html.classList.remove('is-lock-scroll');
		helpers.$body.style.removeProperty('padding-right');
		helpers.$header.style.removeProperty('right');

		helpers.$header.classList.remove('is-menu-opened');
		helpers.restoreScrollPosition();
		helpers.$header.style.removeProperty('top');

		document.querySelector('.modal__scroller').removeEventListener('scroll', modalScroll, false);
	}

	document.querySelectorAll('.header__link').forEach((item) => {
		item.classList.remove('is-active');
	});

	document.querySelector('.grid').classList.remove('is-modal-opened');

	gsap.to(body, {
		autoAlpha: 0,
		scale: helpers.isMobile() ? 1 : 0.5,
		clearProps: 'all',
		onComplete() {
			modal.classList.remove('is-active');
			modal.classList.add('is-hidden');
			helpers.dispatcher.trigger('cards-hide', {name: body.querySelector('.modal-title').textContent});
			parallax.enabled();
			body.parentElement.style.setProperty('--height', '100%');

			body.innerHTML = '';
			if (body.classList.contains('modal__body--person')) {
				body.classList.remove('modal__body--person');
			}

			router.navigate('/');

			helpers.modalLocked = false;

			setTimeout(() => {
				helpers.handlerPointerEvents.add();
			}, 500);
		},
	});
}

function init() {
	document.querySelectorAll('.js-modal-close').forEach((item) => {
		if (!item.dataset.init) {
			item.addEventListener('click', (e) => {
				e.preventDefault();

				close();
			}, false);
			item.dataset.init = true;
		}
	});

	document.querySelectorAll('.modal__scroller').forEach((item) => {
		item.addEventListener('click', (e) => {
			if (!e.target.nodeName === 'A') {
				e.preventDefault();
			}
			const container = e.currentTarget.querySelector('.modal__content');

			if (e.target !== container && !container.contains(e.target)) {
				close();
			}
		}, false);
	});

	document.querySelectorAll('.js-modal-arrow-prev, .js-modal-arrow-next').forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();

			const num = e.currentTarget.dataset.target;

			const id = modalToArrayEntries[num][0];

			helpers.dispatcher.trigger('cards-switch', {name: modalToArrayEntries[num][1].title});
			router.navigate(id);
		});
	});

	document.addEventListener('keyup', (e) => {
		if (document.documentElement.dataset.modal && e.key === 'Escape') {
			close();
		}
	});
}

export default {
	init,
	open,
	close,
};
